<template>
  <div>
    <v-modal-contents ref="modal_contents_agree" >

      <template v-slot:close>
        <!--        убираем close-->
        <div></div>
      </template>

      <template v-slot:title>

        <div class="terms_of_use__title mt-30 pl-3 ">
          <div class="h2_title">Условия использования персональных данных</div>

        </div>

      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <div v-html="terms"></div>
          <div class="mt-30">
            <button class="px-30 btn_bordered "
                    @click="$refs.modal_contents_agree.modal_open()">
              Прочитал
            </button>

          </div>
        </div>
      </template>
    </v-modal-contents>

    <v-form ref="form" class="form_upload" v-model="valid" lazy-validation>
      <div>
        <div class="item">
          <div class="form_upload__item">
            <v-text-field
                v-model="s_name"
                :rules="s_nameRules"
                required=""
                solo
                id="s_name"
                placeholder="Фамилия *"
            ></v-text-field>

          </div>
        </div>
        <div class="item">
          <div class="form_upload__item">
            <v-text-field
                v-model="name"
                :rules="nameRules"
                required=""
                solo
                id="name"
                placeholder="Имя *"
            ></v-text-field>

          </div>
        </div>
        <div class="item">
          <div class="form_upload__item">
            <v-text-field
                v-model="patronymic"
                required=""
                solo
                id="patronymic"
                placeholder="Отчество"
            ></v-text-field>

          </div>
        </div>
        <div class="item">
          <div class="form_upload__item">
            <v-text-field
                v-model="company"
                required=""
                solo
                id="company"
                placeholder="Компания"
            ></v-text-field>

          </div>
        </div>

        <div class="item">
          <div class="form_upload__item">
            <v-text-field
                v-model="email"
                :rules="emailRules"
                required
                solo
                id="email"
                placeholder="E-mail *"
            ></v-text-field>

          </div>
        </div>


        <div class="item">
          <div class="form_upload__item d-flex align-items-center justify-content-between mt-5 mb-35">

            <div class="btn_form">
              <v-btn :disabled="!valid" class="px-30 btn_red" @click="sendForm">
                <span>Отправить</span>
              </v-btn>

              <!--            <v-btn color="error" class="mr-4" @click="reset"> Reset Form</v-btn>-->
              <!--            <v-btn color="warning" @click="resetValidation"> Reset Validation</v-btn>-->
            </div>
          </div>

        </div>


      </div>
    </v-form>

  </div>

</template>
<script>
import VModalContents from './modal_contents.vue';

export default {
  name: "form_contact",
  components: {
    VModalContents: VModalContents,
  },
  delimiters: ["${", "}"], // Avoid Twig conflicts
  data() {
    return {
      valid: true,
      terms_of_use: false,

      name: "",
      nameRules: [
        (v) => (!!v) || "Поле 'Имя' не может быть пустым",
        (v) => (v && v.length >= 3) || "Поле 'Имя' не может быть меньше 3 символов",
      ],

      patronymic: "",

      s_name: "",
      s_nameRules: [
        (v) => (!!v) || "Поле 'Фамилия' не может быть пустым",
        (v) => (v && v.length >= 3) || "Поле 'Имя' не может быть меньше 3 символов",
      ],

      email: "",
      emailRules: [
        (v) => !!v || "E-mail обязателен для заполнения",
        (v) => /.+@.+\..+/.test(v) || "E-mail заполнен неправильно",
      ],
      company: "",

      checkbox: false,
      consentToInform: false,
    };
  },


  methods: {
    linkOpen(url) {
      window.open(url, '_blank');
    },
    sendForm() {

      if (!this.$refs.form.validate()) return false;

      var VueObject = this;

      // состояние полей
      // VueObject.name
      // VueObject.s_name
      // VueObject.city
      // VueObject.email
      // VueObject.patronymic
      // VueObject.company

      let url = '/ajax/reg_events.php';
      let params = new URLSearchParams();
      params.set('ajaxPost', 'Y');
      params.set('name', VueObject.name);
      params.set("s_name", VueObject.s_name);
      // params.set("city", VueObject.city);
      params.set("email", VueObject.email);
      params.set("patronymic", VueObject.patronymic);
      params.set("company", VueObject.company);
      fetch(url, {method: 'POST', body: params})
          .then(function (response) {
            return response.json();
          })
          .then((data) => {
            console.log("true");
            // вызов диалога с текстом - Регистрация прошла успешно!
            VueObject.$refs.modal_contents_agree.modal_open();
            setTimeout("location.href = 'https://novaroll.ru';",1500);
          });

      // сброс полей формы
      VueObject.reset();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },

};
</script>


<style lang="scss">
@import "../../theme/_variable.scss";

.reg_events {
  max-width: 460px;
  width: 100%;
  padding: 0px 20px;
  margin-top: 180px !important;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06);
  border-radius: 15px;

  & .reg_events__title {
    padding: 30px 0;
  }

  & .btn_form {
    width: 100%;

    button {
      background: #FA4237;
      border-radius: 10px;
    }
  }
}
</style>

<style lang="scss" scoped>

.drag_form {
  background: rgba(249, 66, 55, 0.06);
  border: 1px dashed #f94237 !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "RobotoRegular";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000000;
  opacity: 0.7;
  text-align: center;

}

</style>